import { Badge } from "@mantine/core";

import { UserStatus } from "@/types/user";

const STATUS_CONFIG: Record<
  UserStatus,
  { label: string; color: string; textColor: string }
> = {
  [UserStatus.Active]: {
    label: "ACTIVE",
    color: "mint-green.2",
    textColor: "mint-green.10",
  },
  [UserStatus.Invited]: {
    label: "INVITED",
    color: "gray.1",
    textColor: "gray.7",
  },
  [UserStatus.Inactive]: {
    label: "INACTIVE",
    color: "yellow.2",
    textColor: "#706000",
  },
};

interface StatusBadgeProps {
  status?: UserStatus;
}

export const StatusBadge = ({ status }: StatusBadgeProps) => {
  const displayStatus = status ?? UserStatus.Active;
  const config = STATUS_CONFIG[displayStatus];

  return (
    <Badge
      className="min-w-20 h-6 px-2 py-0.5 uppercase font-bold text-xs tracking-wider"
      color={config.color}
      c={config.textColor}
      variant="filled"
      radius="xl"
    >
      {config.label}
    </Badge>
  );
};
